function getSignTypeDisplay(sign_type){
    if (typeof sign_type === "undefined" || sign_type === null || sign_type === "") return "- / -";
    else if (sign_type === "ONLINE") return "Online";
    else if (sign_type === "OFFLINE") return "Offline";
    else return "- / -";
}
export default getSignTypeDisplay;